module.exports = __webpack_public_path__ + "img/deezer.653db45f.png";